import FAQ from "../../components/faq";
import { Anulicense } from "../../license";


const BlogContentPageOne = () => {
  const faqData = [
    {
      id: 1,
      question: "What types of businesses need printing services in Mysore?",
      answer:
        "Any business — from startups and shops to real estate firms and event planners — needs professional print materials.",
    },
    {
      id: 2,
      question: "Is offset or digital printing better for flyers?",
      answer:
        "Offset is better for bulk. Digital is quicker for small batches. Choose based on quantity and timeline.",
    },
    {
      id: 3,
      question: "How fast can I get prints done in Mysore?",
      answer:
        "Many shops offer same-day or 2-day delivery for basic items like business cards or flyers.",
    },
    {
      id: 4,
      question: "Are there eco-friendly printing options in Mysore?",
      answer:
        "Yes. Ask for recycled paper and soy-based ink. Some companies specialize in sustainable printing.",
    },
    {
      id: 5,
      question: "Can I order prints online in Mysore?",
      answer:
        "We accept all major credit cards (Visa, MasterCard, American Express, Discover), PayPal, Apple Pay, Google Pay, and Shop Pay. All transactions are secured with SSL encryption.",
    },
    {
      id: 6,
      question: "How do I contact customer support?",
      answer:
        "Yes, many shops accept orders via WhatsApp or email and deliver to your doorstep.",
    },
  ];
  return (
   <section className="bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
          <div className="mb-8 sm:mb-12 lg:mb-16">
            <div className="w-full max-w-4xl mx-auto">
              <img
                src={Anulicense.blogImg1}
                alt="Top Printing Services in Mysore"
                className="w-full h-48 sm:h-64 lg:h-80 object-cover rounded-lg sm:rounded-xl shadow-lg"
              />
            </div>
          </div>
          <div className="max-w-4xl mx-auto space-y-8 sm:space-y-12 lg:space-y-16">
            
           
            <div className="space-y-4 sm:space-y-6">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight">
                Top Printing Services in Mysore for Businesses and Startups
              </h1>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                It's frustrating, isn't it? You plan an event or launch a new product, rush to get your brochures or business cards printed, and the final result looks dull, misaligned, or worse — delayed! Many startups and small businesses in Mysore face this exact issue when they don't choose the right printing partner. Let's make sure you don't go through that. In this blog, we'll walk you through how to find the best printing services in Mysore, what to expect, and how it can actually save your time, money, and reputation.
              </p>
            </div>

            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                Why printing still matters in a digital world
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                Even in 2025, print media has its own magic. Think of flyers that catch attention at traffic signals, product catalogs at exhibitions, or smart packaging for your brand. These physical elements give your business a <strong>real presence</strong> — something that screens can't do alone. That's why choosing the right <strong>printing company in Mysore</strong> becomes so important. If you compromise on quality or miss a deadline, it directly affects your brand's image. This is especially true for startups trying to build trust quickly.
              </p>
            </div>

            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                What do printing services in Mysore include?
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                Most companies offer more than just printing. Here's what you can expect:
              </p>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700">
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Business cards</strong> that look sharp and feel premium</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Brochures and flyers</strong> for promotions or exhibitions</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Letterheads, envelopes, and corporate kits</strong> to show professionalism</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Packaging prints</strong> for small product businesses</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Posters, banners, and signage</strong> for events or shopfronts</span>
                </li>
              </ul>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mt-4">
                Whether you need small batches or bulk orders, a reliable <strong>Mysore printing shop</strong> will guide you through paper types, sizes, and finishes — even if you're totally new to all this.
              </p>
            </div>

            {/* Section 3 */}
            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                Why it matters for your business
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                Startups and small businesses often focus on cost. But going for the cheapest printer usually means:
              </p>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700 mb-6">
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span>Low-quality paper that tears easily</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span>Ink that fades after a week</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span>Delayed delivery and poor customer support</span>
                </li>
              </ul>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                Investing in <strong>professional printing Mysore</strong> may feel slightly more expensive upfront. But you gain:
              </p>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700">
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span>A better first impression</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span>Consistent brand identity</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span>Timely delivery for your launches or events</span>
                </li>
              </ul>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mt-4">
                And the best part? Many top printers in Mysore offer packages for startups with reasonable pricing.
              </p>
            </div>

            {/* Section 4 */}
            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                What does it cost?
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                Printing costs depend on size, quantity, paper type, and finish. Here's a general idea for Mysore in 2025:
              </p>
              <ul className="space-y-2 text-base sm:text-lg text-gray-700">
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Business cards</strong> – ₹150 to ₹500 per 100 cards</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>A5 Flyers</strong> – ₹2.5 to ₹6 per piece for 1000 prints</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Brochures</strong> – ₹5 to ₹12 per brochure depending on color and folds</span>
                </li>
                <li className="flex items-start">
                  <span className="tex-primary mr-3">•</span>
                  <span><strong>Large Banners</strong> – ₹20 to ₹40 per square foot</span>
                </li>
              </ul>
              <div className="bg-secondary p-4 sm:p-6 rounded-lg mt-6">
                <p className="text-base sm:text-lg text-primary font-medium mb-2">
                  💡 Money-saving tip:
                </p>
                <p className="text-base text-white">
                  Try bulk orders, matte finish instead of glossy, or 170 GSM paper instead of 300 GSM if you don't need thick stock.
                </p>
              </div>
            </div>

            {/* Section 5 */}
            <div className="space-y-4 sm:space-y-6">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                How to choose the right printer in Mysore
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                Don't just Google and pick the top result. Here's what to actually do:
              </p>
              <ol className="space-y-3 text-base sm:text-lg text-gray-700">
                <li className="flex items-start">
                  <span className="bg-primary text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5 flex-shrink-0">1</span>
                  <span><strong>Ask for samples</strong> - See their past work before committing.</span>
                </li>
                <li className="flex items-start">
                  <span className="bg-primary text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5 flex-shrink-0">2</span>
                  <span><strong>Check customer reviews</strong> – Real feedback helps avoid bad experiences.</span>
                </li>
                <li className="flex items-start">
                  <span className="bg-primary text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5 flex-shrink-0">3</span>
                  <span><strong>Discuss delivery timelines</strong> – Especially if you're planning for an event.</span>
                </li>
                <li className="flex items-start">
                  <span className="bg-primary text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5 flex-shrink-0">4</span>
                  <span><strong>Ask about file formats</strong> – Some printers may require .PDF, others .AI or .CDR.</span>
                </li>
                <li className="flex items-start">
                  <span className="bg-primary text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-medium mr-3 mt-0.5 flex-shrink-0">5</span>
                  <span><strong>Visit the store</strong> if possible – A quick visit helps build trust and clears doubts.</span>
                </li>
              </ol>
            </div>

            {/* Conclusion Section */}
            <div className="space-y-4 sm:space-y-6 bg-gray-50 p-6 sm:p-8 rounded-xl">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
                Conclusion
              </h2>
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                Good printing is not just ink on paper — it's about communication, trust, and the impression you leave behind. If you're a growing business in Mysore, invest in a printer who understands your needs and timelines. One smart choice can save you days of frustration and help your brand look professional from day one.
              </p>
              <div className="bg-primary text-white p-4 sm:p-6 rounded-lg">
                <p className="text-base sm:text-lg leading-relaxed">
                  <strong>At Anu Offset Prints</strong>, we provide quality offset printing solutions with care and precision. You can visit us at C-12 (KSSIDC), KIADB Industrial Area, Nanjangud - 571302 or call us directly at <strong>08221-225668</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <FAQ faqData={faqData} />
      </div>
    </section>
  );
};

export default BlogContentPageOne;
